export const projects = [
  {
    title: "EQ Bank",
    subtitle: "Java, Rx Java, Room, Dagger, Retrofit, Google Analytics, Fastlane",
    description:
      "Finance Android App, app was named #1 Bank in Canada on the Forbes 2023 Best Banks, in this app you can do all of your everyday banking tasks like check your account balances, deposit cheques, transfer funds, pay bills, and send money with our redesigned user-friendly mobile app. ",
    image: "./project1.gif",
    link: "https://play.google.com/store/apps/details?id=com.eqbank.eqbank&hl=en",
  },
  {
    title: "Bluebird",
    subtitle: "Kotlin, RxJava, Room, Dagger, Retrofit, Fastlane",
    description:
      "Bluebird is a financial account where you manage your card, it offers flexibility and convenience to take control of your money. You can move money in and out of your account, also manage your family accounts and set goals. ",
    image: "./project2.gif",
    link: "https://play.google.com/store/apps/details?id=com.bluebird.mobile&hl=es&gl=US",
  },
  {
    title: "Experian",
    subtitle: "Java, Kotlin, Compose, Coroutines, Dagger/Hilt, Retrofit, Apollo(GraphQL), CI/CD on AWS",
    description:
      "Comprehensive financial empowerment platform leveraging Experian services. Users can access their credit report and FICO® Score seamlessly with a free membership, incorporating features like Experian Boost® for instant score improvement. The app includes credit change alerts and facilitates easy account management through an FDIC-insured, fee-free Experian Smart Money™ Digital Checking Account. Premium benefits such as bill negotiation and Experian CreditLock enhance the user experience. The project aims to simplify financial management and promote credit wellness.",
    image: "./project3.gif",
    link: "https://play.google.com/store/apps/details?id=com.experian.android&hl=en_US",
  },
  {
    title: "Emma App",
    subtitle: "Kotlin, Java, Jetpack Compose, Hilt, Retrofit, Google Analytics, Firebase, Fastlane, Unit Testing",
    description:
      "This application extends lines of credit to valuable customers, empowering them to seamlessly purchase products from our affiliated stores and withdraw cash with ease and security. It's a user friendly and secure app",
    image: "./project4.gif",
    link: "https://play.google.com/store/apps/details?id=com.yellowpepper.unicomer.unipay.prod&hl=es_CR&gl=US",
  },
  {
    title: "Rogers Bank",
    subtitle: "Kotlin, Java, XML Layouts, Data Binding, Hilt, Retrofit, Gson, Firebase, GitLab, Jira, Unit Testing",
    description:
      "The Rogers Bank app is a banking application designed for Canadian customers to manage their Rogers Bank Mastercard accounts conveniently. It offer account management, cash back rewards, customized alerts, wallet integration and much more. ​",
    image: "./project5.gif",
    link: "https://play.google.com/store/apps/details?id=com.rogers.banking",
  },
  {
    title: "Scene+",
    subtitle: "Kotlin, Jetpack Compose, Coroutines, Hilt, Retrofit, Gson, Firebase, GitLab, Jira",
    description:
      "The Scene+ app is a comprehensive loyalty program platform in Canada, enabling members to earn and redeem points across various categories such as entertainment, travel, dining, shopping, groceries, and banking. It's a collaborative initiative by Cineplex, Scotiabank, and Empire Company (owner of Sobeys), designed to provide flexible rewards for everyday spending.​",
    image: "./project6.gif",
    link: "https://play.google.com/store/apps/details?id=com.scene.mobile",
  },
  {
    title: "A&W",
    subtitle: "Kotlin, Jetpack Compose, Coroutines, Hilt, Room, Retrofit, Gson, Firebase, GitLab, Jira, Analytics, Crashlytics",
    description:
      "Collaborated on the maintaince and bug fixing of this mobile app that streamlines ordering and rewards for customers of a fast-food chain. Additionally collaborated in the development of a Loyalty Program feature, where users earn points with every purchase, these points can be exchanged with rewards, such as Fries, Drinks, Desserts, Combos.",
    image: "./project7.gif",
    link: "https://play.google.com/store/apps/details?id=com.myelane2_aw",
  }
];

export const skills = [
  "Kotlin",
  "Java",
  "Python",
  "Retrofit",
  "Jetpack Compose",
  "Material Design",
  "Dagger/Hilt",
  "RxJava",
  "Coroutines",
  "Unit Testing",
  "Room",
  "SQLite",
  "Apollo(GraphQL)",
  "Git",
  "Gitlab",
  "Jira",
  "Firebase",
  "Figma",
  "Google Analytics",
  "Google Crashlytics",
  "Fastlane",
];



// WEBPACK FOOTER //
// ./src/data.js